// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"touch_loader_loaderWrapper__bc5bD","loader":"touch_loader_loader__rBPfY","shadowPulse":"touch_loader_shadowPulse__3WtbE"};